exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "pre[_v-1491c0c9]{margin:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-1491c0c9&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./demo/Data.vue
 ** module id = 39
 ** module chunks = 0
 **/